/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";

export const ChartContainer = styled.div`
  width: 10rem;
  height: 10rem;
`;
